<template>
  <div>
    <el-form v-model="formData" label-width="100px" size="small">
      <el-row :gutter="10">
        <el-col :span="7">
          <el-form-item
            :label="$l('INDEX.fabric_label_groupSpecName') || '规格名称'"
          >
            <b-form-input
              size="sm"
              :placeholder="
                $l('INDEX.form_placeholder_production_order_group_spec_name') ||
                  '请输入规格名称'
              "
              clearable
              type="search"
              v-model.trim="formData.groupSpecName"
              @keyup.enter="query()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_material_no') || '辅料编号'
            "
          >
            <b-form-input
              size="sm"
              :placeholder="
                $l('INDEX.form_placeholder_production_order_material_no') ||
                  '请输入辅料编号'
              "
              clearable
              type="search"
              v-model.trim="formData.materialNo"
              @keyup.enter="query()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
           label-width="120px" 
            :label="
              $l('INDEX.form_label_production_order_material_name') ||
                '辅料名称'
            "
          >
            <b-form-input
              size="sm"
              :placeholder="
                $l('INDEX.form_placeholder_production_order_material_name') ||
                  '请输入辅料名称'
              "
              clearable
              type="search"
              v-model.trim="formData.materialName"
              @keyup.enter="query()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-primary"
            @click="query()"
          >
            {{ $l('INDEX.btn_search') || '搜索' }}
          </b-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return { formData: {} }
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query', this.formData)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form .el-form-item {
  margin-bottom: 0 !important;
}
</style>
